import { pubSub } from '@utils/PubSub';
import { mountVueWithPinia } from '../vue/mountVue';
import App from '../vue/Cart/App.vue';

export class CartApp extends HTMLElement {
  constructor(context) {
    super();
    this.mountApp = this.mount.bind(this);
    if (context) {
      pubSub.subscribe('dy:promo:init', this.mountApp, this.mountApp);
    }
  }
  mount() {
    pubSub.unsubscribe('dy:promo:init', this.mountApp, this.mountApp);
    const root = document.querySelector('.js-cart') ?? false;
    if (!root) return;
    this.mountWithUrgency();
    mountVueWithPinia('.js-cart', App);
  }
  mountWithUrgency() {
    const timer = window?.Brooklinen?.promo?.urgency?.timer || false;
    const timeToCountDown =
      window?.Brooklinen?.promo?.urgency?.timeToCountDown || 1;
    const timeToNudge = window?.Brooklinen?.promo?.urgency?.timeToNudge || 1;
    const alreadySet = sessionStorage.getItem('urgencySet');

    if (!alreadySet) {
      sessionStorage.setItem('urgencyEnabled', timer);
      sessionStorage.setItem('timeToNudge', timeToNudge);
      sessionStorage.setItem('timeToCountDown', timeToCountDown);
    }
  }
}
customElements.define('main-cart', CartApp);
